module.exports = __webpack_public_path__ + "static/media/icon-piece4-5.790f4fe8.png";